import React, { useState } from 'react';
import sportsService from '../services/sportsService';
import './LocationScheduleView.css';

const LocationScheduleView = ({ 
  schedules = [], 
  compact = false,
  showSports = true,
  onScheduleEdit = null,
  onScheduleDelete = null 
}) => {
  const [availableSports, setAvailableSports] = useState([]);

  // Cargar deportes disponibles
  React.useEffect(() => {
    const loadSports = async () => {
      if (!showSports || availableSports.length > 0) return;
      
      try {
        const allSports = await sportsService.getSportsByCategory();
        const flatSports = Object.values(allSports).flat();
        setAvailableSports(flatSports);
      } catch (error) {
        console.error('Error cargando deportes:', error);
      }
    };

    loadSports();
  }, [showSports, availableSports.length]);

  const getSportInfo = (sportId) => {
    if (!sportId || !showSports) return null;
    return availableSports.find(sport => sport.id === sportId);
  };

  const formatDays = (days) => {
    if (!days || days.length === 0) return 'Sin días especificados';
    
    const dayNames = {
      'lunes': 'Lun',
      'martes': 'Mar', 
      'miércoles': 'Mié',
      'jueves': 'Jue',
      'viernes': 'Vie',
      'sábado': 'Sáb',
      'domingo': 'Dom'
    };
    
    return days.map(day => dayNames[day] || day).join(', ');
  };

  const formatTime = (time) => {
    if (!time) return 'No especificado';
    return time;
  };

  const getStatusBadge = (isActive) => {
    return (
      <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
        {isActive ? 'Activo' : 'Inactivo'}
      </span>
    );
  };

  if (schedules.length === 0) {
    return (
      <div className="no-schedules">
        <p>No hay horarios configurados para esta ubicación.</p>
      </div>
    );
  }

  return (
    <div className={`location-schedule-view ${compact ? 'compact' : ''}`}>
      <div className="schedules-header">
        <h4>📅 Horarios de Práctica</h4>
        <span className="schedule-count">{schedules.length} horario{schedules.length > 1 ? 's' : ''}</span>
      </div>

      <div className="schedules-list">
        {schedules.map((schedule, index) => {
          const sportInfo = getSportInfo(schedule.sport_id);
          
          return (
            <div key={schedule.id || index} className="schedule-item">
              <div className="schedule-header">
                <div className="schedule-title">
                  <h5>{schedule.description || `Horario ${index + 1}`}</h5>
                  {getStatusBadge(schedule.is_active)}
                </div>
                
                {(onScheduleEdit || onScheduleDelete) && (
                  <div className="schedule-actions">
                    {onScheduleEdit && (
                      <button 
                        onClick={() => onScheduleEdit(schedule, index)}
                        className="btn btn-sm btn-secondary"
                        title="Editar horario"
                      >
                        ✏️
                      </button>
                    )}
                    {onScheduleDelete && (
                      <button 
                        onClick={() => onScheduleDelete(schedule, index)}
                        className="btn btn-sm btn-danger"
                        title="Eliminar horario"
                      >
                        🗑️
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div className="schedule-details">
                <div className="schedule-info">
                  <div className="info-item">
                    <strong>👥 Público:</strong> 
                    <span>{schedule.target_audience || 'No especificado'}</span>
                  </div>

                  {showSports && sportInfo && (
                    <div className="info-item">
                      <strong>🏃 Deporte:</strong> 
                      <span className="sport-info">
                        {sportInfo.icon} {sportInfo.label}
                      </span>
                    </div>
                  )}

                  <div className="info-item">
                    <strong>📅 Días:</strong> 
                    <span>{formatDays(schedule.days)}</span>
                  </div>

                  <div className="info-item">
                    <strong>⏰ Horario:</strong> 
                    <span>
                      {formatTime(schedule.start_time)} - {formatTime(schedule.end_time)}
                    </span>
                  </div>

                  <div className="info-item">
                    <strong>👥 Máx. Estudiantes:</strong> 
                    <span>{schedule.max_students || 'No especificado'}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LocationScheduleView;
